// Script-strict bilingual text selection, shared by the visitor app (src/App.js) and the admin
// visitor preview (#407) so the preview cannot drift from what the Directory renders: a value
// in the wrong script for the active language is rejected and the caller's fallback is shown.
export const ARABIC_SCRIPT_RE = /[؀-ۿ]/;
export const LATIN_SCRIPT_RE = /[A-Za-z]/;

export const cleanLocalizedText = value => (value == null ? '' : String(value).trim());

export const textMatchesActiveLanguage = (value, isRTL) => {
  const text = cleanLocalizedText(value);
  if (!text) return false;
  return isRTL ? !LATIN_SCRIPT_RE.test(text) : !ARABIC_SCRIPT_RE.test(text);
};

export const strictLocalizedText = ({ en, ar, isRTL, fallbackEn, fallbackAr }) => {
  const primary = isRTL ? ar : en;
  const fallback = isRTL ? fallbackAr : fallbackEn;
  return textMatchesActiveLanguage(primary, isRTL) ? cleanLocalizedText(primary) : fallback;
};
